import React, { Component } from 'react'
import ContextMenuComponent from './ContextMenuComponent'
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import NumberFormat from 'react-number-format';
import PieChart, {Series,Label,Connector,Font,Legend,SmallValuesGrouping} from 'devextreme-react/pie-chart';
import piechart from '../assets/piechart.png'
import linearchart from '../assets/linearchart.png'


// DevExpress.config({
//     rtlEnabled: true
// });

export default class Charts extends Component {
    constructor(props) {
        super(props);


        this.fields = { text: 'title', value: 'target' };

        this.btnClick = this.btnClick.bind(this);
        this.menuClicked = this.menuClicked.bind(this);
        this.updateChart = this.updateChart.bind(this);

        this.conmenu = React.createRef();
        this.chartElement = React.createRef();

        this.state={
            totalCostWidth:0,
            totalPriceWidth:0,
            totalBenefitWidth:0,
            totalDPSWidth:0,
            depositWidth:0,
            creditWidth:0,
            netCashWidth:0,
            brokerProfitWidth:0,
            totalProfitWidth:0,
            pieData:{},
            devPieData:[],
            currentType:'total_price',
            totalCostNegetiveWidth:0,
            totalPriceNegetiveWidth:0,
            totalBenefitNegetiveWidth:0,
            totalDPSNegetiveWidth:0,
            depositNegetiveWidth:0,
            creditNegetiveWidth:0,
            totalProfitNegetiveWidth:0,
            netCashNegetiveWidth:0,
            brokerProfitNegetiveWidth:0,
            paletteColor:["#014b63","#006579","#008084","#009a83","#32b377"],
        }
    }

    componentDidUpdate(prevProps){
        if (prevProps.data!==this.props.data){
            this.updateChart(this.state.currentType)
        }
    }

    componentDidMount(){
        this.updateChart(this.state.currentType)
    }


    isEqual(a,b) 
    { 
        // if length is not equal 
        if(a.length!==b.length)  return false; 
        else
        { 
            for(var i=0;i<a.length;i++){
                if(a[i].y!==b[i].y)  return false;
            }
            return true; 
        }
    }

    updateChart(target){
        if (this.props.type==="pie" && this.props.data.length>0){
            let data = [];
            if (target==="cost"){
                this.setState({currentType:'cost'});
            }else if (target==="benefit"){
                this.setState({currentType:'benefit'});
            }else if (target==="total_price"){
                this.setState({currentType:'total_price'});
            }else if (target==="price"){
                this.setState({currentType:'price'});
            }

            this.props.data.forEach(function(entry) {
                
                let name;
                let value;
                if (entry.industry_name===undefined){
                    name=entry.symbol;
                }else{
                    name=entry.industry_name;
                }

                if (target==="cost"){
                    value=entry.cost;
                }else if (target==="benefit"){
                    value=entry.benefit
                }else if (target==="total_price"){
                    value=entry.total_price
                }
                // else if (target==="price"){
                //     value=entry.price
                // }
                data.push({label:name,y:value})
            });

            if (!this.isEqual(this.state.devPieData,data)){
                this.setState({devPieData:data})
            }
            
        }
        else if (this.props.type==="bar"){
            // console.log(this.props.data);
            let aa=[{text:'totalCost',value:this.props.data.totalCost},{text:'totalPrice',value:this.props.data.totalPrice},{text:'totalBenefit',value:this.props.data.totalBenefit},{text:'totalDPS',value:this.props.data.totalDPS},{text:'deposit',value:this.props.data.deposit},{text:'credit',value:this.props.data.credit},{text:'netCash',value:this.props.data.netCash},{text:'brokerProfit',value:this.props.data.brokerProfit},{text:'totalProfit',value:this.props.data.totalProfit}];
            //,{text:'brnefitPerDeposit',value:this.props.data.brnefitPerDeposit}
            // console.log(aa);
            let last=0;
            let lastname;
            aa.forEach(function(entry) {
                if (Math.abs(entry.value)>last){
                    last=entry.value;
                    lastname=entry.text;
                }
            });

            
            if (lastname==='totalCost'){

                if (this.props.data.totalCost>0){
                    this.setState({totalCostNegetiveWidth:0,totalCostWidth:100})
                }else if (this.props.data.totalCost<0){
                    this.setState({totalCostNegetiveWidth:100,totalCostWidth:0})
                }else{
                    this.setState({totalCostNegetiveWidth:0,totalCostWidth:0})
                }


                if (this.props.data.totalPrice>0){
                    this.setState({totalPriceNegetiveWidth:0,totalPriceWidth:Math.abs(this.calc(this.props.data.totalCost,this.props.data.totalPrice))})
                }else if (this.props.data.totalPrice<0){
                    this.setState({totalPriceNegetiveWidth:Math.abs(this.calc(this.props.data.totalCost,this.props.data.totalPrice)),totalPriceWidth:0})
                }else{
                    this.setState({totalPriceNegetiveWidth:0,totalPriceWidth:0})
                }

                // if (this.props.data.totalBenefit>0){
                //     this.setState({totalBenefitNegetiveWidth:0,totalBenefitWidth:Math.abs(this.calc(this.props.data.totalCost,this.props.data.totalBenefit))})
                // }else if (this.props.data.totalBenefit<0){
                //     this.setState({totalBenefitNegetiveWidth:Math.abs(this.calc(this.props.data.totalCost,this.props.data.totalBenefit)),totalBenefitWidth:0})
                // }else{
                //     this.setState({totalBenefitNegetiveWidth:0,totalBenefitWidth:0})
                // }

                if (this.props.data.totalDPS>0){
                    this.setState({totalDPSNegetiveWidth:0,totalDPSWidth:Math.abs(this.calc(this.props.data.totalCost,this.props.data.totalDPS))})
                }else if (this.props.data.totalDPS<0){
                    this.setState({totalDPSNegetiveWidth:Math.abs(this.calc(this.props.data.totalCost,this.props.data.totalDPS)),totalDPSWidth:0})
                }else{
                    this.setState({totalDPSNegetiveWidth:0,totalDPSWidth:0})
                }

                if (this.props.data.deposit>0){
                    this.setState({depositNegetiveWidth:0,depositWidth:Math.abs(this.calc(this.props.data.totalCost,this.props.data.deposit))})
                }else if (this.props.data.deposit<0){
                    this.setState({depositNegetiveWidth:Math.abs(this.calc(this.props.data.totalCost,this.props.data.deposit)),depositWidth:0})
                }else{
                    this.setState({depositNegetiveWidth:0,depositWidth:0})
                }

                if (this.props.data.credit>0){
                    this.setState({creditNegetiveWidth:0,creditWidth:Math.abs(this.calc(this.props.data.totalCost,this.props.data.credit))})
                }else if (this.props.data.credit<0){
                    this.setState({creditNegetiveWidth:Math.abs(this.calc(this.props.data.totalCost,this.props.data.credit)),creditWidth:0})
                }else{
                    this.setState({creditNegetiveWidth:0,creditWidth:0})
                }

                if (this.props.data.totalProfit>0){
                    this.setState({totalProfitNegetiveWidth:0,totalProfitWidth:Math.abs(this.calc(this.props.data.totalCost,this.props.data.totalProfit))})
                }else if (this.props.data.totalProfit<0){
                    this.setState({totalProfitNegetiveWidth:Math.abs(this.calc(this.props.data.totalCost,this.props.data.totalProfit)),totalProfitWidth:0})
                }else{
                    this.setState({totalProfitNegetiveWidth:0,totalProfitWidth:0})
                }

                if (this.props.data.brokerProfit>0){
                    this.setState({brokerProfitNegetiveWidth:0,brokerProfitWidth:Math.abs(this.calc(this.props.data.totalCost,this.props.data.brokerProfit))})
                }else if (this.props.data.brokerProfit<0){
                    this.setState({brokerProfitNegetiveWidth:Math.abs(this.calc(this.props.data.totalCost,this.props.data.brokerProfit)),brokerProfitWidth:0})
                }else{
                    this.setState({brokerProfitNegetiveWidth:0,brokerProfitWidth:0})
                }

                if (this.props.data.netCash>0){
                    this.setState({netCashNegetiveWidth:0,netCashWidth:Math.abs(this.calc(this.props.data.totalCost,this.props.data.netCash))})
                }else if (this.props.data.netCash<0){
                    this.setState({netCashNegetiveWidth:Math.abs(this.calc(this.props.data.totalCost,this.props.data.netCash)),netCashWidth:0})
                }else{
                    this.setState({netCashNegetiveWidth:0,netCashWidth:0})
                }

            }else if (lastname==='totalPrice'){

                if (this.props.data.totalPrice>0){
                    this.setState({totalPriceNegetiveWidth:0,totalPriceWidth:100})
                }else if (this.props.data.totalPrice<0){
                    this.setState({totalPriceNegetiveWidth:100,totalPriceWidth:0})
                }else{
                    this.setState({totalPriceNegetiveWidth:0,totalPriceWidth:0})
                }


                if (this.props.data.totalCost>0){
                    this.setState({totalCostNegetiveWidth:0,totalCostWidth:Math.abs(this.calc(this.props.data.totalPrice,this.props.data.totalCost))})
                }else if (this.props.data.totalCost<0){
                    this.setState({totalCostNegetiveWidth:Math.abs(this.calc(this.props.data.totalPrice,this.props.data.totalCost)),totalCostWidth:0})
                }else{
                    this.setState({totalCostNegetiveWidth:0,totalCostWidth:0})
                }



                // if (this.props.data.totalBenefit>0){
                //     this.setState({totalBenefitNegetiveWidth:0,totalBenefitWidth:Math.abs(this.calc(this.props.data.totalPrice,this.props.data.totalBenefit))})
                // }else if (this.props.data.totalBenefit<0){
                //     this.setState({totalBenefitNegetiveWidth:Math.abs(this.calc(this.props.data.totalPrice,this.props.data.totalBenefit)),totalBenefitWidth:0})
                // }else{
                //     this.setState({totalBenefitNegetiveWidth:0,totalBenefitWidth:0})
                // }

                if (this.props.data.totalDPS>0){
                    this.setState({totalDPSNegetiveWidth:0,totalDPSWidth:Math.abs(this.calc(this.props.data.totalPrice,this.props.data.totalDPS))})
                }else if (this.props.data.totalDPS<0){
                    this.setState({totalDPSNegetiveWidth:Math.abs(this.calc(this.props.data.totalPrice,this.props.data.totalDPS)),totalDPSWidth:0})
                }else{
                    this.setState({totalDPSNegetiveWidth:0,totalDPSWidth:0})
                }

                if (this.props.data.deposit>0){
                    this.setState({depositNegetiveWidth:0,depositWidth:Math.abs(this.calc(this.props.data.totalPrice,this.props.data.deposit))})
                }else if (this.props.data.deposit<0){
                    this.setState({depositNegetiveWidth:Math.abs(this.calc(this.props.data.totalPrice,this.props.data.deposit)),depositWidth:0})
                }else{
                    this.setState({depositNegetiveWidth:0,depositWidth:0})
                }

                if (this.props.data.credit>0){
                    this.setState({creditNegetiveWidth:0,creditWidth:Math.abs(this.calc(this.props.data.totalPrice,this.props.data.credit))})
                }else if (this.props.data.credit<0){
                    this.setState({creditNegetiveWidth:Math.abs(this.calc(this.props.data.totalPrice,this.props.data.credit)),creditWidth:0})
                }else{
                    this.setState({creditNegetiveWidth:0,creditWidth:0})
                }

                if (this.props.data.totalProfit>0){
                    this.setState({totalProfitNegetiveWidth:0,totalProfitWidth:Math.abs(this.calc(this.props.data.totalPrice,this.props.data.totalProfit))})
                }else if (this.props.data.totalProfit<0){
                    this.setState({totalProfitNegetiveWidth:Math.abs(this.calc(this.props.data.totalPrice,this.props.data.totalProfit)),totalProfitWidth:0})
                }else{
                    this.setState({totalProfitNegetiveWidth:0,totalProfitWidth:0})
                }

                if (this.props.data.brokerProfit>0){
                    this.setState({brokerProfitNegetiveWidth:0,brokerProfitWidth:Math.abs(this.calc(this.props.data.totalPrice,this.props.data.brokerProfit))})
                }else if (this.props.data.brokerProfit<0){
                    this.setState({brokerProfitNegetiveWidth:Math.abs(this.calc(this.props.data.totalPrice,this.props.data.brokerProfit)),brokerProfitWidth:0})
                }else{
                    this.setState({brokerProfitNegetiveWidth:0,brokerProfitWidth:0})
                }

                if (this.props.data.netCash>0){
                    this.setState({netCashNegetiveWidth:0,netCashWidth:Math.abs(this.calc(this.props.data.totalPrice,this.props.data.netCash))})
                }else if (this.props.data.netCash<0){
                    this.setState({netCashNegetiveWidth:Math.abs(this.calc(this.props.data.totalPrice,this.props.data.netCash)),netCashWidth:0})
                }else{
                    this.setState({netCashNegetiveWidth:0,netCashWidth:0})
                }

            }else if (lastname==='totalDPS'){

                if (this.props.data.totalDPS>0){
                    this.setState({totalDPSNegetiveWidth:0,totalDPSWidth:100})
                }else if (this.props.data.totalDPS<0){
                    this.setState({totalDPSNegetiveWidth:100,totalDPSWidth:0})
                }else{
                    this.setState({totalDPSNegetiveWidth:0,totalDPSWidth:0})
                }


                if (this.props.data.totalCost>0){
                    this.setState({totalCostNegetiveWidth:0,totalCostWidth:Math.abs(this.calc(this.props.data.totalDPS,this.props.data.totalCost))})
                }else if (this.props.data.totalCost<0){
                    this.setState({totalCostNegetiveWidth:Math.abs(this.calc(this.props.data.totalDPS,this.props.data.totalCost)),totalCostWidth:0})
                }else{
                    this.setState({totalCostNegetiveWidth:0,totalCostWidth:0})
                }



                if (this.props.data.totalPrice>0){
                    this.setState({totalPriceNegetiveWidth:0,totalPriceWidth:Math.abs(this.calc(this.props.data.totalDPS,this.props.data.totalPrice))})
                }else if (this.props.data.totalPrice<0){
                    this.setState({totalPriceNegetiveWidth:Math.abs(this.calc(this.props.data.totalDPS,this.props.data.totalPrice)),totalPriceWidth:0})
                }else{
                    this.setState({totalPriceNegetiveWidth:0,totalPriceWidth:0})
                }


                // if (this.props.data.totalBenefit>0){
                //     this.setState({totalBenefitNegetiveWidth:0,totalBenefitWidth:Math.abs(this.calc(this.props.data.totalDPS,this.props.data.totalBenefit))})
                // }else if (this.props.data.totalBenefit<0){
                //     this.setState({totalBenefitNegetiveWidth:Math.abs(this.calc(this.props.data.totalDPS,this.props.data.totalBenefit)),totalBenefitWidth:0})
                // }else{
                //     this.setState({totalBenefitNegetiveWidth:0,totalBenefitWidth:0})
                // }

                if (this.props.data.deposit>0){
                    this.setState({depositNegetiveWidth:0,depositWidth:Math.abs(this.calc(this.props.data.totalDPS,this.props.data.deposit))})
                }else if (this.props.data.deposit<0){
                    this.setState({depositNegetiveWidth:Math.abs(this.calc(this.props.data.totalDPS,this.props.data.deposit)),depositWidth:0})
                }else{
                    this.setState({depositNegetiveWidth:0,depositWidth:0})
                }

                if (this.props.data.credit>0){
                    this.setState({creditNegetiveWidth:0,creditWidth:Math.abs(this.calc(this.props.data.totalDPS,this.props.data.credit))})
                }else if (this.props.data.credit<0){
                    this.setState({creditNegetiveWidth:Math.abs(this.calc(this.props.data.totalDPS,this.props.data.credit)),creditWidth:0})
                }else{
                    this.setState({creditNegetiveWidth:0,creditWidth:0})
                }

                if (this.props.data.totalProfit>0){
                    this.setState({totalProfitNegetiveWidth:0,totalProfitWidth:Math.abs(this.calc(this.props.data.totalDPS,this.props.data.totalProfit))})
                }else if (this.props.data.totalProfit<0){
                    this.setState({totalProfitNegetiveWidth:Math.abs(this.calc(this.props.data.totalDPS,this.props.data.totalProfit)),totalProfitWidth:0})
                }else{
                    this.setState({totalProfitNegetiveWidth:0,totalProfitWidth:0})
                }

                if (this.props.data.brokerProfit>0){
                    this.setState({brokerProfitNegetiveWidth:0,brokerProfitWidth:Math.abs(this.calc(this.props.data.totalDPS,this.props.data.brokerProfit))})
                }else if (this.props.data.brokerProfit<0){
                    this.setState({brokerProfitNegetiveWidth:Math.abs(this.calc(this.props.data.totalDPS,this.props.data.brokerProfit)),brokerProfitWidth:0})
                }else{
                    this.setState({brokerProfitNegetiveWidth:0,brokerProfitWidth:0})
                }

                if (this.props.data.netCash>0){
                    this.setState({netCashNegetiveWidth:0,netCashWidth:Math.abs(this.calc(this.props.data.totalDPS,this.props.data.netCash))})
                }else if (this.props.data.netCash<0){
                    this.setState({netCashNegetiveWidth:Math.abs(this.calc(this.props.data.totalDPS,this.props.data.netCash)),netCashWidth:0})
                }else{
                    this.setState({netCashNegetiveWidth:0,netCashWidth:0})
                }
            }else if (lastname==='deposit'){

                if (this.props.data.deposit>0){
                    this.setState({depositNegetiveWidth:0,depositWidth:100})
                }else if (this.props.data.deposit<0){
                    this.setState({depositNegetiveWidth:100,depositWidth:0})
                }else{
                    this.setState({depositNegetiveWidth:0,depositWidth:0})
                }


                if (this.props.data.totalCost>0){
                    this.setState({totalCostNegetiveWidth:0,totalCostWidth:Math.abs(this.calc(this.props.data.deposit,this.props.data.totalCost))})
                }else if (this.props.data.totalCost<0){
                    this.setState({totalCostNegetiveWidth:Math.abs(this.calc(this.props.data.deposit,this.props.data.totalCost)),totalCostWidth:0})
                }else{
                    this.setState({totalCostNegetiveWidth:0,totalCostWidth:0})
                }



                if (this.props.data.totalPrice>0){
                    this.setState({totalPriceNegetiveWidth:0,totalPriceWidth:Math.abs(this.calc(this.props.data.deposit,this.props.data.totalPrice))})
                }else if (this.props.data.totalPrice<0){
                    this.setState({totalPriceNegetiveWidth:Math.abs(this.calc(this.props.data.deposit,this.props.data.totalPrice)),totalPriceWidth:0})
                }else{
                    this.setState({totalPriceNegetiveWidth:0,totalPriceWidth:0})
                }


                // if (this.props.data.totalBenefit>0){
                //     this.setState({totalBenefitNegetiveWidth:0,totalBenefitWidth:Math.abs(this.calc(this.props.data.deposit,this.props.data.totalBenefit))})
                // }else if (this.props.data.totalBenefit<0){
                //     this.setState({totalBenefitNegetiveWidth:Math.abs(this.calc(this.props.data.deposit,this.props.data.totalBenefit)),totalBenefitWidth:0})
                // }else{
                //     this.setState({totalBenefitNegetiveWidth:0,totalBenefitWidth:0})
                // }

                if (this.props.data.totalDPS>0){
                    this.setState({totalDPSNegetiveWidth:0,totalDPSWidth:Math.abs(this.calc(this.props.data.deposit,this.props.data.totalDPS))})
                }else if (this.props.data.totalDPS<0){
                    this.setState({totalDPSNegetiveWidth:Math.abs(this.calc(this.props.data.deposit,this.props.data.totalDPS)),totalDPSWidth:0})
                }else{
                    this.setState({totalDPSNegetiveWidth:0,totalDPSWidth:0})
                }


                if (this.props.data.credit>0){
                    this.setState({creditNegetiveWidth:0,creditWidth:Math.abs(this.calc(this.props.data.deposit,this.props.data.credit))})
                }else if (this.props.data.credit<0){
                    this.setState({creditNegetiveWidth:Math.abs(this.calc(this.props.data.deposit,this.props.data.credit)),creditWidth:0})
                }else{
                    this.setState({creditNegetiveWidth:0,creditWidth:0})
                }

                if (this.props.data.totalProfit>0){
                    this.setState({totalProfitNegetiveWidth:0,totalProfitWidth:Math.abs(this.calc(this.props.data.deposit,this.props.data.totalProfit))})
                }else if (this.props.data.totalProfit<0){
                    this.setState({totalProfitNegetiveWidth:Math.abs(this.calc(this.props.data.deposit,this.props.data.totalProfit)),totalProfitWidth:0})
                }else{
                    this.setState({totalProfitNegetiveWidth:0,totalProfitWidth:0})
                }

                if (this.props.data.brokerProfit>0){
                    this.setState({brokerProfitNegetiveWidth:0,brokerProfitWidth:Math.abs(this.calc(this.props.data.deposit,this.props.data.brokerProfit))})
                }else if (this.props.data.brokerProfit<0){
                    this.setState({brokerProfitNegetiveWidth:Math.abs(this.calc(this.props.data.deposit,this.props.data.brokerProfit)),brokerProfitWidth:0})
                }else{
                    this.setState({brokerProfitNegetiveWidth:0,brokerProfitWidth:0})
                }

                if (this.props.data.netCash>0){
                    this.setState({netCashNegetiveWidth:0,netCashWidth:Math.abs(this.calc(this.props.data.deposit,this.props.data.netCash))})
                }else if (this.props.data.netCash<0){
                    this.setState({netCashNegetiveWidth:Math.abs(this.calc(this.props.data.deposit,this.props.data.netCash)),netCashWidth:0})
                }else{
                    this.setState({netCashNegetiveWidth:0,netCashWidth:0})
                }
            }else if (lastname==='credit'){

                if (this.props.data.credit>0){
                    this.setState({creditNegetiveWidth:0,creditWidth:100})
                }else if (this.props.data.credit<0){
                    this.setState({creditNegetiveWidth:100,creditWidth:0})
                }else{
                    this.setState({creditNegetiveWidth:0,creditWidth:0})
                }


                if (this.props.data.totalCost>0){
                    this.setState({totalCostNegetiveWidth:0,totalCostWidth:Math.abs(this.calc(this.props.data.credit,this.props.data.totalCost))})
                }else if (this.props.data.totalCost<0){
                    this.setState({totalCostNegetiveWidth:Math.abs(this.calc(this.props.data.credit,this.props.data.totalCost)),totalCostWidth:0})
                }else{
                    this.setState({totalCostNegetiveWidth:0,totalCostWidth:0})
                }



                if (this.props.data.totalPrice>0){
                    this.setState({totalPriceNegetiveWidth:0,totalPriceWidth:Math.abs(this.calc(this.props.data.credit,this.props.data.totalPrice))})
                }else if (this.props.data.totalPrice<0){
                    this.setState({totalPriceNegetiveWidth:Math.abs(this.calc(this.props.data.credit,this.props.data.totalPrice)),totalPriceWidth:0})
                }else{
                    this.setState({totalPriceNegetiveWidth:0,totalPriceWidth:0})
                }


                // if (this.props.data.totalBenefit>0){
                //     this.setState({totalBenefitNegetiveWidth:0,totalBenefitWidth:Math.abs(this.calc(this.props.data.credit,this.props.data.totalBenefit))})
                // }else if (this.props.data.totalBenefit<0){
                //     this.setState({totalBenefitNegetiveWidth:Math.abs(this.calc(this.props.data.credit,this.props.data.totalBenefit)),totalBenefitWidth:0})
                // }else{
                //     this.setState({totalBenefitNegetiveWidth:0,totalBenefitWidth:0})
                // }

                if (this.props.data.totalDPS>0){
                    this.setState({totalDPSNegetiveWidth:0,totalDPSWidth:Math.abs(this.calc(this.props.data.credit,this.props.data.totalDPS))})
                }else if (this.props.data.totalDPS<0){
                    this.setState({totalDPSNegetiveWidth:Math.abs(this.calc(this.props.data.credit,this.props.data.totalDPS)),totalDPSWidth:0})
                }else{
                    this.setState({totalDPSNegetiveWidth:0,totalDPSWidth:0})
                }



                if (this.props.data.deposit>0){
                    this.setState({depositNegetiveWidth:0,depositWidth:Math.abs(this.calc(this.props.data.credit,this.props.data.deposit))})
                }else if (this.props.data.deposit<0){
                    this.setState({depositNegetiveWidth:Math.abs(this.calc(this.props.data.credit,this.props.data.deposit)),depositWidth:0})
                }else{
                    this.setState({depositNegetiveWidth:0,depositWidth:0})
                }

                if (this.props.data.totalProfit>0){
                    this.setState({totalProfitNegetiveWidth:0,totalProfitWidth:Math.abs(this.calc(this.props.data.credit,this.props.data.totalProfit))})
                }else if (this.props.data.totalProfit<0){
                    this.setState({totalProfitNegetiveWidth:Math.abs(this.calc(this.props.data.credit,this.props.data.totalProfit)),totalProfitWidth:0})
                }else{
                    this.setState({totalProfitNegetiveWidth:0,totalProfitWidth:0})
                }

                if (this.props.data.brokerProfit>0){
                    this.setState({brokerProfitNegetiveWidth:0,brokerProfitWidth:Math.abs(this.calc(this.props.data.credit,this.props.data.brokerProfit))})
                }else if (this.props.data.brokerProfit<0){
                    this.setState({brokerProfitNegetiveWidth:Math.abs(this.calc(this.props.data.credit,this.props.data.brokerProfit)),brokerProfitWidth:0})
                }else{
                    this.setState({brokerProfitNegetiveWidth:0,brokerProfitWidth:0})
                }

                if (this.props.data.netCash>0){
                    this.setState({netCashNegetiveWidth:0,netCashWidth:Math.abs(this.calc(this.props.data.credit,this.props.data.netCash))})
                }else if (this.props.data.netCash<0){
                    this.setState({netCashNegetiveWidth:Math.abs(this.calc(this.props.data.credit,this.props.data.netCash)),netCashWidth:0})
                }else{
                    this.setState({netCashNegetiveWidth:0,netCashWidth:0})
                }
            }else if (lastname==='netCash'){

                if (this.props.data.netCash>0){
                    this.setState({netCashNegetiveWidth:0,netCashWidth:100})
                }else if (this.props.data.netCash<0){
                    this.setState({netCashNegetiveWidth:100,netCashWidth:0})
                }else{
                    this.setState({netCashNegetiveWidth:0,netCashWidth:0})
                }


                if (this.props.data.totalCost>0){
                    this.setState({totalCostNegetiveWidth:0,totalCostWidth:Math.abs(this.calc(this.props.data.netCash,this.props.data.totalCost))})
                }else if (this.props.data.totalCost<0){
                    this.setState({totalCostNegetiveWidth:Math.abs(this.calc(this.props.data.netCash,this.props.data.totalCost)),totalCostWidth:0})
                }else{
                    this.setState({totalCostNegetiveWidth:0,totalCostWidth:0})
                }



                if (this.props.data.totalPrice>0){
                    this.setState({totalPriceNegetiveWidth:0,totalPriceWidth:Math.abs(this.calc(this.props.data.netCash,this.props.data.totalPrice))})
                }else if (this.props.data.totalPrice<0){
                    this.setState({totalPriceNegetiveWidth:Math.abs(this.calc(this.props.data.netCash,this.props.data.totalPrice)),totalPriceWidth:0})
                }else{
                    this.setState({totalPriceNegetiveWidth:0,totalPriceWidth:0})
                }


                // if (this.props.data.totalBenefit>0){
                //     this.setState({totalBenefitNegetiveWidth:0,totalBenefitWidth:Math.abs(this.calc(this.props.data.netCash,this.props.data.totalBenefit))})
                // }else if (this.props.data.totalBenefit<0){
                //     this.setState({totalBenefitNegetiveWidth:Math.abs(this.calc(this.props.data.netCash,this.props.data.totalBenefit)),totalBenefitWidth:0})
                // }else{
                //     this.setState({totalBenefitNegetiveWidth:0,totalBenefitWidth:0})
                // }


                if (this.props.data.totalDPS>0){
                    this.setState({totalDPSNegetiveWidth:0,totalDPSWidth:Math.abs(this.calc(this.props.data.netCash,this.props.data.totalDPS))})
                }else if (this.props.data.totalDPS<0){
                    this.setState({totalDPSNegetiveWidth:Math.abs(this.calc(this.props.data.netCash,this.props.data.totalDPS)),totalDPSWidth:0})
                }else{
                    this.setState({totalDPSNegetiveWidth:0,totalDPSWidth:0})
                }



                if (this.props.data.deposit>0){
                    this.setState({depositNegetiveWidth:0,depositWidth:Math.abs(this.calc(this.props.data.netCash,this.props.data.deposit))})
                }else if (this.props.data.deposit<0){
                    this.setState({depositNegetiveWidth:Math.abs(this.calc(this.props.data.netCash,this.props.data.deposit)),depositWidth:0})
                }else{
                    this.setState({depositNegetiveWidth:0,depositWidth:0})
                }


                if (this.props.data.credit>0){
                    this.setState({creditNegetiveWidth:0,creditWidth:Math.abs(this.calc(this.props.data.netCash,this.props.data.credit))})
                }else if (this.props.data.credit<0){
                    this.setState({creditNegetiveWidth:Math.abs(this.calc(this.props.data.netCash,this.props.data.credit)),creditWidth:0})
                }else{
                    this.setState({creditNegetiveWidth:0,creditWidth:0})
                }

                if (this.props.data.totalProfit>0){
                    this.setState({totalProfitNegetiveWidth:0,totalProfitWidth:Math.abs(this.calc(this.props.data.netCash,this.props.data.totalProfit))})
                }else if (this.props.data.totalProfit<0){
                    this.setState({totalProfitNegetiveWidth:Math.abs(this.calc(this.props.data.netCash,this.props.data.totalProfit)),totalProfitWidth:0})
                }else{
                    this.setState({totalProfitNegetiveWidth:0,totalProfitWidth:0})
                }

                if (this.props.data.brokerProfit>0){
                    this.setState({brokerProfitNegetiveWidth:0,brokerProfitWidth:Math.abs(this.calc(this.props.data.netCash,this.props.data.brokerProfit))})
                }else if (this.props.data.brokerProfit<0){
                    this.setState({brokerProfitNegetiveWidth:Math.abs(this.calc(this.props.data.netCash,this.props.data.brokerProfit)),brokerProfitWidth:0})
                }else{
                    this.setState({brokerProfitNegetiveWidth:0,brokerProfitWidth:0})
                }

            }else if (lastname==='brokerProfit'){

                if (this.props.data.brokerProfit>0){
                    this.setState({brokerProfitNegetiveWidth:0,brokerProfitWidth:100})
                }else if (this.props.data.brokerProfit<0){
                    this.setState({brokerProfitNegetiveWidth:100,brokerProfitWidth:0})
                }else{
                    this.setState({brokerProfitNegetiveWidth:0,brokerProfitWidth:0})
                }


                if (this.props.data.totalCost>0){
                    this.setState({totalCostNegetiveWidth:0,totalCostWidth:Math.abs(this.calc(this.props.data.brokerProfit,this.props.data.totalCost))})
                }else if (this.props.data.totalCost<0){
                    this.setState({totalCostNegetiveWidth:Math.abs(this.calc(this.props.data.brokerProfit,this.props.data.totalCost)),totalCostWidth:0})
                }else{
                    this.setState({totalCostNegetiveWidth:0,totalCostWidth:0})
                }



                if (this.props.data.totalPrice>0){
                    this.setState({totalPriceNegetiveWidth:0,totalPriceWidth:Math.abs(this.calc(this.props.data.brokerProfit,this.props.data.totalPrice))})
                }else if (this.props.data.totalPrice<0){
                    this.setState({totalPriceNegetiveWidth:Math.abs(this.calc(this.props.data.brokerProfit,this.props.data.totalPrice)),totalPriceWidth:0})
                }else{
                    this.setState({totalPriceNegetiveWidth:0,totalPriceWidth:0})
                }


                // if (this.props.data.totalBenefit>0){
                //     this.setState({totalBenefitNegetiveWidth:0,totalBenefitWidth:Math.abs(this.calc(this.props.data.brokerProfit,this.props.data.totalBenefit))})
                // }else if (this.props.data.totalBenefit<0){
                //     this.setState({totalBenefitNegetiveWidth:Math.abs(this.calc(this.props.data.brokerProfit,this.props.data.totalBenefit)),totalBenefitWidth:0})
                // }else{
                //     this.setState({totalBenefitNegetiveWidth:0,totalBenefitWidth:0})
                // }


                if (this.props.data.totalDPS>0){
                    this.setState({totalDPSNegetiveWidth:0,totalDPSWidth:Math.abs(this.calc(this.props.data.brokerProfit,this.props.data.totalDPS))})
                }else if (this.props.data.totalDPS<0){
                    this.setState({totalDPSNegetiveWidth:Math.abs(this.calc(this.props.data.brokerProfit,this.props.data.totalDPS)),totalDPSWidth:0})
                }else{
                    this.setState({totalDPSNegetiveWidth:0,totalDPSWidth:0})
                }



                if (this.props.data.deposit>0){
                    this.setState({depositNegetiveWidth:0,depositWidth:Math.abs(this.calc(this.props.data.brokerProfit,this.props.data.deposit))})
                }else if (this.props.data.deposit<0){
                    this.setState({depositNegetiveWidth:Math.abs(this.calc(this.props.data.brokerProfit,this.props.data.deposit)),depositWidth:0})
                }else{
                    this.setState({depositNegetiveWidth:0,depositWidth:0})
                }


                if (this.props.data.credit>0){
                    this.setState({creditNegetiveWidth:0,creditWidth:Math.abs(this.calc(this.props.data.brokerProfit,this.props.data.credit))})
                }else if (this.props.data.credit<0){
                    this.setState({creditNegetiveWidth:Math.abs(this.calc(this.props.data.brokerProfit,this.props.data.credit)),creditWidth:0})
                }else{
                    this.setState({creditNegetiveWidth:0,creditWidth:0})
                }

                if (this.props.data.totalProfit>0){
                    this.setState({totalProfitNegetiveWidth:0,totalProfitWidth:Math.abs(this.calc(this.props.data.brokerProfit,this.props.data.totalProfit))})
                }else if (this.props.data.totalProfit<0){
                    this.setState({totalProfitNegetiveWidth:Math.abs(this.calc(this.props.data.brokerProfit,this.props.data.totalProfit)),totalProfitWidth:0})
                }else{
                    this.setState({totalProfitNegetiveWidth:0,totalProfitWidth:0})
                }

                if (this.props.data.netCash>0){
                    this.setState({netCashNegetiveWidth:0,netCashWidth:Math.abs(this.calc(this.props.data.brokerProfit,this.props.data.netCash))})
                }else if (this.props.data.netCash<0){
                    this.setState({netCashNegetiveWidth:Math.abs(this.calc(this.props.data.brokerProfit,this.props.data.netCash)),netCashWidth:0})
                }else{
                    this.setState({netCashNegetiveWidth:0,netCashWidth:0})
                }
            }else if (lastname==='totalProfit'){

                if (this.props.data.totalProfit>0){
                    this.setState({totalProfitNegetiveWidth:0,totalProfitWidth:100})
                }else if (this.props.data.totalProfit<0){
                    this.setState({totalProfitNegetiveWidth:100,totalProfitWidth:0})
                }else{
                    this.setState({totalProfitNegetiveWidth:0,totalProfitWidth:0})
                }


                if (this.props.data.totalCost>0){
                    this.setState({totalCostNegetiveWidth:0,totalCostWidth:Math.abs(this.calc(this.props.data.totalProfit,this.props.data.totalCost))})
                }else if (this.props.data.totalCost<0){
                    this.setState({totalCostNegetiveWidth:Math.abs(this.calc(this.props.data.totalProfit,this.props.data.totalCost)),totalCostWidth:0})
                }else{
                    this.setState({totalCostNegetiveWidth:0,totalCostWidth:0})
                }



                if (this.props.data.totalPrice>0){
                    this.setState({totalPriceNegetiveWidth:0,totalPriceWidth:Math.abs(this.calc(this.props.data.totalProfit,this.props.data.totalPrice))})
                }else if (this.props.data.totalPrice<0){
                    this.setState({totalPriceNegetiveWidth:Math.abs(this.calc(this.props.data.totalProfit,this.props.data.totalPrice)),totalPriceWidth:0})
                }else{
                    this.setState({totalPriceNegetiveWidth:0,totalPriceWidth:0})
                }


                if (this.props.data.totalDPS>0){
                    this.setState({totalDPSNegetiveWidth:0,totalDPSWidth:Math.abs(this.calc(this.props.data.totalProfit,this.props.data.totalDPS))})
                }else if (this.props.data.totalDPS<0){
                    this.setState({totalDPSNegetiveWidth:Math.abs(this.calc(this.props.data.totalProfit,this.props.data.totalDPS)),totalDPSWidth:0})
                }else{
                    this.setState({totalDPSNegetiveWidth:0,totalDPSWidth:0})
                }



                if (this.props.data.deposit>0){
                    this.setState({depositNegetiveWidth:0,depositWidth:Math.abs(this.calc(this.props.data.totalProfit,this.props.data.deposit))})
                }else if (this.props.data.deposit<0){
                    this.setState({depositNegetiveWidth:Math.abs(this.calc(this.props.data.totalProfit,this.props.data.deposit)),depositWidth:0})
                }else{
                    this.setState({depositNegetiveWidth:0,depositWidth:0})
                }


                if (this.props.data.credit>0){
                    this.setState({creditNegetiveWidth:0,creditWidth:Math.abs(this.calc(this.props.data.totalProfit,this.props.data.credit))})
                }else if (this.props.data.credit<0){
                    this.setState({creditNegetiveWidth:Math.abs(this.calc(this.props.data.totalProfit,this.props.data.credit)),creditWidth:0})
                }else{
                    this.setState({creditNegetiveWidth:0,creditWidth:0})
                }

                if (this.props.data.brokerProfit>0){
                    this.setState({brokerProfitNegetiveWidth:0,brokerProfitWidth:Math.abs(this.calc(this.props.data.totalProfit,this.props.data.brokerProfit))})
                }else if (this.props.data.brokerProfit<0){
                    this.setState({brokerProfitNegetiveWidth:Math.abs(this.calc(this.props.data.totalProfit,this.props.data.brokerProfit)),brokerProfitWidth:0})
                }else{
                    this.setState({brokerProfitNegetiveWidth:0,brokerProfitWidth:0})
                }

                if (this.props.data.netCash>0){
                    this.setState({netCashNegetiveWidth:0,netCashWidth:Math.abs(this.calc(this.props.data.totalProfit,this.props.data.netCash))})
                }else if (this.props.data.netCash<0){
                    this.setState({netCashNegetiveWidth:Math.abs(this.calc(this.props.data.totalProfit,this.props.data.netCash)),netCashWidth:0})
                }else{
                    this.setState({netCashNegetiveWidth:0,netCashWidth:0})
                }
            }
        }
    }

    calc(a,b){
        return 100-Math.abs(((b-a)/a)*100)
    }

    menuClicked(target){
        this.setState({currentType:target});
        this.updateChart(target)
    }

    btnClick() {
        this.conmenu.current.showMenu(this.targett.getBoundingClientRect().bottom+"px",this.targett.getBoundingClientRect().left+"px");
    }

    

    

    render() {
        return (
            <div ref={this.chartElement} className={this.props.chartName==='chart1'?"chartBG pieChartStyle chart1":"chartBG pieChartStyle"}>
                <div style={{display:'flex',justifyContent:'flex-end',direction:'rtl'}}>
                    {this.props.type!=="line" && <div style={{width:'100%',fontSize:'13px'}}><img src={this.props.type==="pie" ? piechart:linearchart} style={{height:'20px',marginLeft:'10px'}} alt="piechart"/>{this.props.title}</div>}
                    {this.props.basedOn && <div className="transButton" id="targett" style={{height:'20px'}} ref={(scope) => this.targett = scope} onClick={this.btnClick}><FontAwesomeIcon className={!this.props.selected ? "transButtonContent":"transButtonContentSelected"} icon={faEllipsisV} /></div>}
                </div>

                <div className="chartsContainer">
                        {this.props.type==="pie" && <PieChart
                            className="myPieChart"
                            dataSource={this.state.devPieData}
                            palette={this.state.paletteColor}
                            onPointClick={this.pointClickHandler}
                            onLegendClick={this.legendClickHandler}
                            resolveLabelOverlapping='shift'
                            sizeGroup="piesGroup"
                            rtlEnabled={true}
                        >
                            <Legend orientation="horizontal"
                            itemTextPosition="left"
                            horizontalAlignment="center"
                            verticalAlignment="bottom"
                            columnCount={4}>
                                <Font color="var(--textcolor1)" family="IRANSansMobile(FaNum)" size={11}/>
                            </Legend>
                            <Series
                            argumentField="label"
                            valueField="y"
                            >
                                <Label visible={true} customizeText={customizeText} wordWrap="none" textOverflow="none">
                                    <Font color="white" family="IRANSansMobile(FaNum)" size={10}/>
                                    <Connector visible={true} width={1} />
                                </Label>
                                <SmallValuesGrouping topCount={5} mode="topN" groupName="سایر" />
                            </Series>
                        </PieChart>}

                        {this.props.type==="bar" && 
                        <div style={{width:'100%',height:'342px',display:'flex',flexDirection:'row',marginTop:'10px',overflow:'hidden'}}>
                            <div style={{width:this.state.totalCostNegetiveWidth>0 || this.state.totalPriceNegetiveWidth>0 || this.state.totalDPSNegetiveWidth>0 || this.state.depositNegetiveWidth>0 || this.state.creditNegetiveWidth>0 || this.state.brokerProfitNegetiveWidth>0 || this.state.totalProfitNegetiveWidth>0 || this.state.netCashNegetiveWidth>0 ?'100%':'0%',height:'100%',display:'flex',flexDirection:'column',direction:'rtl',transition: 'width 1s'}}>
                                <div style={{width:this.state.depositNegetiveWidth+'%',height:'30px',backgroundColor:'var(--red1)',borderTopLeftRadius:'5px',borderBottomLeftRadius:'5px',margin:'10px 0px',transition: 'width 1s'}} />
                                <div style={{width:this.state.creditNegetiveWidth+'%',height:'30px',backgroundColor:'var(--red1)',borderTopLeftRadius:'5px',borderBottomLeftRadius:'5px',margin:'10px 0px',transition: 'width 1s'}} />
                                <div style={{width:this.state.netCashNegetiveWidth+'%',height:'30px',backgroundColor:'var(--red1)',borderTopLeftRadius:'5px',borderBottomLeftRadius:'5px',margin:'10px 0px',transition: 'width 1s'}} />
                                <div style={{width:this.state.totalCostNegetiveWidth+'%',height:'30px',backgroundColor:'var(--red1)',borderTopLeftRadius:'5px',borderBottomLeftRadius:'5px',margin:'10px 0px',transition: 'width 1s'}} />
                                <div style={{width:this.state.totalPriceNegetiveWidth+'%',height:'30px',backgroundColor:'var(--red1)',borderTopLeftRadius:'5px',borderBottomLeftRadius:'5px',margin:'10px 0px',transition: 'width 1s'}} />
                                <div style={{width:this.state.totalDPSNegetiveWidth+'%',height:'30px',backgroundColor:'var(--red1)',borderTopLeftRadius:'5px',borderBottomLeftRadius:'5px',margin:'10px 0px',transition: 'width 1s'}} />

                                <div style={{width:this.state.brokerProfitNegetiveWidth+'%',height:'30px',backgroundColor:'var(--red1)',borderTopLeftRadius:'5px',borderBottomLeftRadius:'5px',margin:'10px 0px',transition: 'width 1s'}} />

                                <div style={{width:this.state.totalProfitNegetiveWidth+'%',height:'30px',backgroundColor:'var(--red1)',borderTopLeftRadius:'5px',borderBottomLeftRadius:'5px',margin:'10px 0px',transition: 'width 1s'}} />
                            </div>
                            <div style={{height:'100%',minWidth:'4px',backgroundColor:'var(--gray1)',borderRadius:'2px',boxShadow: '0px 0px 5px rgba(173, 173, 173,0.5)'}} />
                            <div style={{width:'100%',height:'100%',display:'flex',flexDirection:'column'}}>
                                <div style={{width:this.state.depositWidth+'%',height:'30px',backgroundColor:'#009a83',borderTopRightRadius:'5px',borderBottomRightRadius:'5px',margin:'10px 0px',transition: 'width 1s'}} />
                                <div style={{width:this.state.creditWidth+'%',height:'30px',backgroundColor:'#009a83',borderTopRightRadius:'5px',borderBottomRightRadius:'5px',margin:'10px 0px',transition: 'width 1s'}} />
                                <div style={{width:this.state.netCashWidth+'%',height:'30px',backgroundColor:'#009a83',borderTopRightRadius:'5px',borderBottomRightRadius:'5px',margin:'10px 0px',transition: 'width 1s'}} />
                                <div style={{width:this.state.totalCostWidth+'%',height:'30px',backgroundColor:'#014b63',borderTopRightRadius:'5px',borderBottomRightRadius:'5px',margin:'10px 0px',transition: 'width 1s'}} />
                                <div style={{width:this.state.totalPriceWidth+'%',height:'30px',backgroundColor:'#006579',borderTopRightRadius:'5px',borderBottomRightRadius:'5px',margin:'10px 0px',transition: 'width 1s'}} />
                                <div style={{width:this.state.totalDPSWidth+'%',height:'30px',backgroundColor:'#009a83',borderTopRightRadius:'5px',borderBottomRightRadius:'5px',margin:'10px 0px',transition: 'width 1s'}} />

                                <div style={{width:this.state.brokerProfitWidth+'%',height:'30px',backgroundColor:'#008084',borderTopRightRadius:'5px',borderBottomRightRadius:'5px',margin:'10px 0px',transition: 'width 1s'}} />

                                <div style={{width:this.state.totalProfitWidth+'%',height:'30px',backgroundColor:'var(--green1)',borderTopRightRadius:'5px',borderBottomRightRadius:'5px',margin:'10px 0px',transition: 'width 1s'}} />
                            </div>

                            <div style={{display:'flex',flexDirection:'column',justifyContent:'center'}}>
                                

                                <div style={{height:'30px',display:'flex',flexDirection:'row-reverse',fontSize:'12px',color:'var(--textcolor1)',margin:'10px 0px 10px 5px',whiteSpace: 'nowrap',alignItems:'center'}}><div style={{direction:'rtl'}}>مجموع واریزها:&nbsp;&nbsp;</div><NumberFormat style={{direction:'ltr'}} value={this.props.data.deposit} displayType={'text'} thousandSeparator={true} />ریال&nbsp;</div>
                                <div style={{height:'30px',display:'flex',flexDirection:'row-reverse',fontSize:'12px',color:'var(--textcolor1)',margin:'10px 0px 10px 5px',whiteSpace: 'nowrap',alignItems:'center'}}><div style={{direction:'rtl'}}>مجموع برداشت ها:&nbsp;&nbsp;</div><NumberFormat style={{direction:'ltr'}} value={this.props.data.credit} displayType={'text'} thousandSeparator={true} />ریال&nbsp;</div>
                                <div style={{height:'30px',display:'flex',flexDirection:'row-reverse',fontSize:'12px',color:'var(--textcolor1)',margin:'10px 0px 10px 5px',whiteSpace: 'nowrap',alignItems:'center'}}><div style={{direction:'rtl'}}>خالص آورده نقدی:&nbsp;&nbsp;</div><NumberFormat style={{direction:'ltr'}} value={this.props.data.netCash} displayType={'text'} thousandSeparator={true} />ریال&nbsp;</div>
                                <div style={{height:'30px',display:'flex',flexDirection:'row-reverse',fontSize:'12px',color:'var(--textcolor1)',margin:'10px 0px 10px 5px',whiteSpace: 'nowrap',alignItems:'center'}} ><div style={{direction:'rtl'}}>بهای تمام شده:&nbsp;&nbsp;</div><NumberFormat style={{direction:'ltr'}} value={this.props.data.totalCost} displayType={'text'} thousandSeparator={true} />ریال&nbsp;</div>
                                <div style={{height:'30px',display:'flex',flexDirection:'row-reverse',fontSize:'12px',color:'var(--textcolor1)',margin:'10px 0px 10px 5px',whiteSpace: 'nowrap',alignItems:'center'}}><div style={{direction:'rtl'}}>ارزش روز:&nbsp;&nbsp;</div><NumberFormat style={{direction:'ltr'}} value={this.props.data.totalPrice} displayType={'text'} thousandSeparator={true} />ریال&nbsp;</div>
                                <div style={{height:'30px',display:'flex',flexDirection:'row-reverse',fontSize:'12px',color:'var(--textcolor1)',margin:'10px 0px 10px 5px',whiteSpace: 'nowrap',alignItems:'center'}}><div style={{direction:'rtl'}}>سود سهام تقسیم شده:&nbsp;&nbsp;</div><NumberFormat style={{direction:'ltr'}} value={this.props.data.totalDPS} displayType={'text'} thousandSeparator={true} />ریال&nbsp;</div>

                                <div style={{height:'30px',display:'flex',flexDirection:'row-reverse',fontSize:'12px',color:'var(--textcolor1)',margin:'10px 0px 10px 5px',whiteSpace: 'nowrap',alignItems:'center'}}><div style={{direction:'rtl'}}>سود کارگزاری:&nbsp;&nbsp;</div><NumberFormat style={{direction:'ltr'}} value={this.props.data.brokerProfit} displayType={'text'} thousandSeparator={true} />ریال&nbsp;</div>

                                <div style={{height:'30px',display:'flex',flexDirection:'row-reverse',fontSize:'12px',color:'var(--textcolor1)',margin:'10px 0px 10px 5px',whiteSpace: 'nowrap',alignItems:'center'}}><div style={{direction:'rtl'}}>سود یا زیان کل:&nbsp;&nbsp;</div><NumberFormat style={{direction:'ltr'}} value={this.props.data.totalProfit} displayType={'text'} thousandSeparator={true} />ریال&nbsp;</div>
                            </div>
                        </div>}
                    </div>
                
                {this.props.basedOn && <ContextMenuComponent data={this.props.basedOn} isChart={true} targett={this.targett} menuClicked={this.menuClicked} ref={this.conmenu} />}
            </div>
        )
    }
}


function customizeText(arg) {
  return `${arg.valueText.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} (${arg.percentText})`;
}